import { getEnv } from '@/utils/globalState'
const getters = {
  sidebar: state => state.app.sidebar,
  stageData: state => state.app.stageData,
  apiData: state => state.app.apiData,
  menuData: state => state.app.menuData,
  siteData: state => state.app.siteData,
  setting: state => state.app.setting,
  env: state => state.app.env,
  storeList: state => state.app.storeList,
  siteConfig: state => state.app.siteConfig,
  token: state => state.user.token,
  devtoken: state => state.user.devtoken,
  name: state => state.user.name,
  site: state => state.user.storeInfo.SITE,
  stock_no: state => state.user.storeInfo.STOCK_NO,
  storeInfo: state => state.user.storeInfo,
  addRouters: state => state.permission.addRouters,
  isLogin: state => state.user.token !== null,
  dateFormat: state => 'YYYY/MM/DD',
  theme: state => state.user.themeColor,
  builderHost: state => {
    const currentStage = getEnv('VUE_APP_STAGE') ? getEnv('VUE_APP_STAGE') : 'develop'
    console.log(currentStage)
    let host = 'dbRDMy'
    if (currentStage.indexOf('master') !== -1 || currentStage.indexOf('nlb') !== -1) {
      host = 'dbJabez'
    } else if (currentStage.indexOf('usdev') !== -1) {
      host = 'dbRDLaundry'
    } else if (currentStage === 'us') {
      host = 'dbLaundry'
    }
    return host
  }
}
export default getters
